
import { Generic } from "./generic";

export class Consultor extends Generic {
    id: string;
    dsconsultor: string;
    dtatualizacao: string;
}